import { z } from '../zod.js';
import { ObjectIdStringValidationSchema } from '../shared/ObjectId';
import { LivemodeFilterValidationSchema } from '../shared/livemode';

export const GetSubscriptionPaymentInputValidationSchema = z.object({
  subscriptionPaymentId: ObjectIdStringValidationSchema.meta({
    description:
      'The ID of the subscription payment to retrieve. Use `list_subscription_payments` first if you need to discover the ID — filter by `subscriptionId` to see every payment on one subscription. This is the ID of a single payment, not the subscription it belongs to.',
  }),
  livemode: LivemodeFilterValidationSchema,
});
